import { journeyAction, } from './base';

import { JourneyActionMailAutoResponse as JourneyActionMailAutoResponseBase, } from 'atlas-shared';

export const JourneyActionMailAutoResponse = journeyAction({
  ...JourneyActionMailAutoResponseBase,
  icon: 'Send',
});
